import { BaseModel } from './base.model';
import { AppDate } from './date.model';

export class OrderWindow extends BaseModel {
  public id: number;
  public entity_id: number;
  public market_year: number;
  public label: string;
  public start_at: AppDate;
  public end_at: AppDate;
  public updated_at: AppDate;
  public active: boolean;
  public upcoming: boolean;
  public market_start_at: AppDate;
  public market_end_at: AppDate;
  public programs_count: number;
  private show_in_bw_calendar: number;

  constructor(data) {
    super(data, {
      num: ['id', 'entity_id', 'programs_count', 'market_year', 'show_in_bw_calendar'],
      date: [
        'start_at',
        'end_at',
        'updated_at',
        'market_start_at',
        'market_end_at',
      ],
      bool: ['active', 'upcoming'],
    });
  }

  get showInCalender(): boolean {
    return !!this.show_in_bw_calendar;
  }
}
